// .env file is returning the flag as a string.
const IS_MOCK = process.env.VUE_APP_IS_MOCK === "true";

export default {
  IS_MOCK,
  API_ENDPOINT: process.env.VUE_APP_API_ENDPOINT,
  BNS_API_ENDPOINT: process.env.VUE_APP_BNS_API_ENDPOINT,
  RECAPTCHA_SITE_KEY: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
  ORGANIZATION: process.env.VUE_APP_ORGANIZATION,
};
